import {
	CLEAR_SHOPINPUTSAVE,
	SHOP_CATEGOTY_SAVED,
	SHOP_CATEGOTY_SAVING,
	SHOP_CATEGOTY_SAVING_FAILED,
} from "../actions/types";

const initialState = {
	isSaving: false,
	isSaved: false,
	isFailed: false,
	data: {},
};
export default function (state = initialState, action) {
	switch (action.type) {
		case SHOP_CATEGOTY_SAVING:
			return {
				...state,
				isSaving: true,
				isSaved: false,
				isFailed: false,
			};
		case SHOP_CATEGOTY_SAVED:
			return {
				...state,
				isSaving: false,
				isSaved: true,
				isFailed: false,
				data: action.payload,
			};
		case SHOP_CATEGOTY_SAVING_FAILED:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isFailed: true,
			};
		case CLEAR_SHOPINPUTSAVE:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isFailed: false,
				data: {},
			};

		default:
			return state;
	}
}
